import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';

const SearchableDropdown = ({
  items,
  selectedItem,
  setSelectedItem,
  onSelect,
  displayKey,
  searchKeys = [],
  placeholder = 'Select an item',
  searchPlaceholder = 'Search...',
  noItemsText = 'No items found',
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState(items);

  useEffect(() => {
    setFilteredItems(
      items.filter((item) =>
        searchKeys.some((key) => item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
      )
    );
  }, [searchTerm, items, searchKeys]);

  const getDisplayValue = (item) => {
    if (typeof displayKey === 'function') {
      return displayKey(item);
    }
    return item[displayKey];
  };

  const handleSelect = (item) => {
    setSelectedItem(item);
    onSelect(item);
    setSearchTerm('');
  };
  return (
    <Dropdown>
      <Dropdown.Toggle
        className="border w-100 text-start d-flex justify-content-between align-items-center text-capitalize text-truncate"
        variant=" "
        id="dropdownMenuButton"
      >
        {selectedItem ? getDisplayValue(selectedItem) : placeholder}
      </Dropdown.Toggle>
      <Dropdown.Menu className="w-100 overflow-auto searchable_dropdown">
        <Dropdown.Item className="text-decoration-none">
          <input
            type="text"
            className="form-control"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown.Item>
        {filteredItems.length > 0 ? (
          filteredItems.map((item, index) => (
            <Dropdown.Item
              key={index}
              onClick={() => handleSelect(item)}
              className={`text-decoration-none text-truncate text-capitalize ${
                selectedItem && getDisplayValue(selectedItem) === getDisplayValue(item)
                  ? 'base-color-bg text-white'
                  : ''
              }`}
            >
              {getDisplayValue(item)}
            </Dropdown.Item>
          ))
        ) : (
          <Dropdown.Item disabled>{noItemsText}</Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SearchableDropdown;
